module.exports = __webpack_public_path__ + "media/images/icons/sort_desc_disabled-0b8bb7875f3792b7bf89d2af6a8b5f20.png";